module.exports = __webpack_public_path__ + "static/img/11.ec4292e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/11.png
// module id = 5VrI
// module chunks = 0